exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  height: 4rem;\n  background-color: #2395f1;\n  text-align: center;\n  line-height: 4rem;\n  color: white;\n}", ""]);

// exports
